import { inject, Service, signal } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { filter } from "rxjs";

import { AdaaHelper } from "../../core/utils";
import { MandatoryFields } from "../models/mandatory-fields-model";
import { MandatoryApiService } from "./mandatory-api-service";

@Service()
export class SmartToolTipsService {
  private _mandatoryApiService = inject(MandatoryApiService);
  private _router = inject(Router);

  isSmartToolTipsEnabled = signal(false);
  hasToolTips = signal(false);
  toolTips = signal<MandatoryFields["parameterCatalogs"]>([]);

  constructor() {
    this._router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => this._resetState());
  }

  private _resetState() {
    this.isSmartToolTipsEnabled.set(false);
    this.hasToolTips.set(false);
    this.toolTips.set([]);
  }

  public toggleToolTips() {
    this.isSmartToolTipsEnabled.update((prev) => !prev);
  }

  public initSmartToolTips(tooltipKey: string) {
    if (!AdaaHelper.isDefinedAndNotEmpty(tooltipKey)) return;

    this._mandatoryApiService.getMandatoryFieldsBySearchKey(tooltipKey).subscribe((response) => {
      if (response.inError) return;
      const toolTips = response.responseData?.parameterCatalogs ?? [];
      this.hasToolTips.set(toolTips.length > 0);
      this.toolTips.set(toolTips);
    });
  }
}
